import { Component, OnInit, OnDestroy, DoCheck, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService, AuthenticationService } from 'src/app/shared/_services';
import { ModalController, Platform } from '@ionic/angular';
import { SelectPaymentMethodPage } from 'src/app/shared/modals/select-payment-method/select-payment-method.page';
import { ShadowService } from 'src/app/shared/_services/shadow.service';
import { DashboardStore, LoginStore, PaymentsStore } from 'src/app/shared/_services/store';
import { CloseOverlayService } from 'src/app/shared/_services/closeOverlay.service';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.page.html',
  styleUrls: ['./payment.page.scss']
})
export class PaymentPage implements OnInit, OnDestroy, DoCheck {
  @ViewChild('amountId', { static: false }) amountInput: any;
  paymentMethod = 'bankTransfer';
  header: any;
  amount: any;
  accountName: any;
  bankCode: any;
  phone: any;
  description: any;
  subscription: any;
  selectBank = false;
  disabled = true;
  hideSpinner = true;
  hideError = true;
  banks = [];
  numbers = [1, 2, 3, 4, 5, 6, 7, 8, 9];
  numbersAfterDecimal: any;
  inputHasFocus: boolean;

  constructor(
    private router: Router,
    private platform: Platform,
    private route: ActivatedRoute,
    private loginStore: LoginStore,
    private alertService: AlertService,
    private auth: AuthenticationService,
    private shadowService: ShadowService,
    private paymentsStore: PaymentsStore,
    private modalController: ModalController,
    private closeOverlayService: CloseOverlayService
  ) {}

  displayNumber(num: any) {
    if (this.numbersAfterDecimal.length !== 2) {
      this.amount = this.amount.concat(num);
    }
  }

  addDecimal() {
    if (!this.amount.includes('.') && this.amount.length > 1) {
      this.amount = this.amount.concat('.');
    }
  }

  addZero() {
    if (parseInt(this.amount, 10) > 0 && this.numbersAfterDecimal.length !== 2) {
      this.amount = this.amount.concat(0);
    }
  }

  clear() {
    this.amount = '';
    this.numbersAfterDecimal = 0;
  }

  deleteNumber() {
    this.amount = this.amount.slice(0, -1);
  }

  noSpace(ev: any) {
    if (ev.keyCode === 32 && this.accountName.length < 1) {
      return false;
    }
  }

  async changePaymentMethod() {
    const modal = await this.modalController.create({
      component: SelectPaymentMethodPage,
      backdropDismiss: true,
      showBackdrop: true,
      swipeToClose: true,
      // mode: 'ios',
      cssClass: 'bottom-modal create-dispute h-50'
    });
    return await modal.present();
  }

  makeNewDemoPayment() {
    this.paymentsStore.setAmount(this.amount);
    this.hideSpinner = false;
    this.disabled = true;
    if (this.paymentMethod === 'bankTransfer') {
      this.auth.demoBankTransferPayment(this.amount, this.phone, this.description, this.accountName)
      .subscribe(
        response => {
          console.log(response);
          this.paymentsStore.setBankTransferDetails(response);
          this.router.navigateByUrl('demo/confirm');
          this.hideSpinner = true;
          this.disabled = false;
          this.clear();
        },
        error => {
          console.log(error);
          this.hideSpinner = true;
          this.disabled = false;
          if (error.error.message.includes('400') || error.status === 500) {
            this.alertService.standardAlert('Unable to make Payment. Please check the amount try again');
          } else {
            this.alertService.standardAlert('Unable to make Payment. Please try again');
          }
        }
      );
    } else {
      this.auth.demoUssdPayment(this.amount, this.bankCode)
    .subscribe(
      response => {
        console.log(response);
        this.paymentsStore.setUssdDetails(response);
        this.router.navigateByUrl('demo/confirm');
        this.hideSpinner = true;
        this.clear();
      },
      error => {
        console.log(error);
        this.hideSpinner = true;
        if (error.error.message.includes('Minimum amount')) {
          this.alertService.standardAlert(error.error.message);
        } else {
          this.alertService.standardAlert('Unable to make Payment. Please try again');
        }
      }
    );
    }
  }

  ngOnInit() {
    this.amount = '';
    this.accountName = this.loginStore.getDemoAccountName();
    this.banks = this.loginStore.getUssdBanks();
    this.paymentsStore.setPaymentMethod('bankTransfer');
    const newPayment = 'demo';
    if (this.route.snapshot.queryParams[newPayment]) {
      this.changePaymentMethod();
    }
    this.loginStore.setShake(true);
    window.onpopstate = (() => {
      this.closeOverlayService.trigger();
    });
    window.addEventListener('keydown', (e) => {
      const num = parseInt(e.key, 10);
      const pathname = window.location.pathname;
      document.querySelectorAll('ion-input').forEach(element => {
        this.inputHasFocus = element.classList.contains('has-focus');
      });
      if (!this.inputHasFocus) {
        if (num > 0 && num <= 9) {
          this.displayNumber(num);
        }
        if (num === 0) {
          this.addZero();
        }
        if (e.key === '.') {
          this.addDecimal();
        }
        if (e.key === 'Backspace') {
          this.deleteNumber();
        }
      }
      if (e.key === 'Enter' && this.disabled === false && pathname.includes('demo/payment')) {
        this.makeNewDemoPayment();
      }
      if (e.key !== 'Tab') {
        this.closeOverlayService.trigger();
      }
    });
  }

  ngDoCheck(): void {
    this.paymentMethod = this.paymentsStore.getPaymentMethod();
    if (this.paymentMethod === 'bankTransfer') {
      this.header = 'Bank Transfer';
      this.selectBank = false;
      if (this.amount.length > 1 && this.accountName.length > 2) {
        this.disabled = false;
        this.hideError = true;
      } else if (this.accountName.length > 0 && this.accountName.length < 3) {
        this.disabled = true;
        this.hideError = false;
      } else if (this.accountName.length === 0) {
        this.disabled = true;
        this.hideError = true;
      } else {
        this.hideError = true;
        this.disabled = true;
      }
    } else if (this.paymentMethod === 'ussd') {
      this.header = 'USSD';
      this.selectBank = true;
      if (this.amount.length > 1 && this.bankCode.length === 3) {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
    } else if (this.paymentMethod === 'cardPayment') {
      this.header = 'Card Payment';
      this.selectBank = false;
    }
    if (this.loginStore.getDemoAccountName() === null) {
      this.loginStore.setDemoAccountName('');
    } else {
      this.loginStore.setDemoAccountName(this.accountName);
    }
    if (this.amount.indexOf('.') !== -1) {
      const remainder = this.amount.slice(this.amount.indexOf('.') + 1);
      this.numbersAfterDecimal = remainder;
    }
  }

  goBack() {
    this.router.navigateByUrl('/login');
  }

  ionViewWillEnter() {
    document.title = 'New Demo Payment | Bank3D';
    this.shadowService.button();
  }

  ionViewDidEnter() {
    const { cbn } = this.banks.find(bank => bank.name);
    this.bankCode = cbn;
    this.bankCode = 0;
    this.numbersAfterDecimal = 0;
    this.subscription = this.platform.backButton.subscribeWithPriority(99999, () => {
      this.goBack();
    });
  }

  ionViewDidLeave() {
    this.subscription.unsubscribe();
  }

  ngOnDestroy() {
  }

}
